import React from 'react';
import * as S from './styles';

interface IContainerBoxProps extends React.HTMLAttributes<HTMLDivElement> {
  title?: string;
  children: React.ReactNode;
  id?: string;
}
function ContainerBox({ title, children,id, ...props }: IContainerBoxProps) {
  const generatedId = id ? `${id}` : 'id-general-container-box';
  return (
    <S.ContainerBox {...props} id={generatedId}>
      {title && <S.Title>{title}</S.Title>}
      {children}
    </S.ContainerBox>
  );
}
export default ContainerBox;